import { disableScrollForInputDrawer, enableScrollForInputDrawer } from '~/js/utils/dom';

const heroProductGalleryModal = () => ({
  currentSlideInfo: '',
  open: false,

  init() {
    this.currentSlideInfo = `1/${this.images.length}`;

    this.mutationObserver = new MutationObserver(this.handleMutation.bind(this));
    this.mutationObserver.observe(this.$el, {
      attributes: true,
      attributeFilter: ['open'],
    });
  },

  destroy() {
    this.mutationObserver.disconnect();
  },

  handleMutation() {
    this.open = this.$el.open;

    if (this.open) {
      disableScrollForInputDrawer();
    } else {
      enableScrollForInputDrawer();
    }
  },
});

export default heroProductGalleryModal;
